import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography
} from '@mui/material';

import { TeamMember } from '../../API';
import { useTeamManagement } from './useTeamManagement';

interface DeleteMemberConfirmationDialogProps {
    open: boolean;
    member: TeamMember | null;
    onClose: () => void;
    onConfirm: () => void;
}

export const DeleteMemberConfirmationDialog = ({
    open,
    member,
    onClose,
    onConfirm
}: DeleteMemberConfirmationDialogProps) => {
    const { getUserById } = useTeamManagement();

    return (
        <Dialog
            open={open}
            onClose={onClose}
        >
            <DialogTitle>Confirm Member Removal</DialogTitle>
            <DialogContent>
                <Typography>
                    Are you sure you want to remove {getUserById(member?.userId ?? '')?.name ?? 'this user'} from the team?
                    This action cannot be undone.
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={onClose}
                    color="warning"
                    variant="contained"
                >
                    Cancel
                </Button>
                <Button
                    onClick={onConfirm}
                    variant="contained"
                    color="error"
                >
                    Remove
                </Button>
            </DialogActions>
        </Dialog>
    );
}; 